import React, { useContext } from "react";
import { connect } from "react-redux";
import { Context } from "@components/useContext/context";
import ImageContainer from "@components/imageContainer";
import DOMPurify from "isomorphic-dompurify";
import {
  CardWrapper,
  HeaderSection,
  HeaderNumber,
  HeaderQuote,
  Divider,
  ContentSection,
  BulletContainer,
  BulletItem,
  IconWrapper,
  BulletText,
  BulletDivider,
  VideoWrapper
} from "./styles";
import { resolvePath } from "@utils/resolvePath";

interface BulletPoint {
  icon?: string;
  text: string;
}

interface ClaimLieCardProps {
  is_visible?: boolean;
  actions?: any;
  lieNumber?: string;
  lieQuote?: string;
  bulletPoints?: BulletPoint[];
  videoTitle?: string;
  videoDuration?: string;
  videoThumbnail?: string;
  videoSrc?: string;
  headerColor?: string;
  bulletIconColor?: string;
  videoBackgroundColor?: string;
}

const ClaimLieCard = (props: ClaimLieCardProps) => {
  const {
    is_visible = true,
    lieNumber,
    lieQuote,
    bulletPoints = [],
    videoTitle,
    videoDuration,
    videoThumbnail,
    videoSrc,
    headerColor,
    bulletIconColor,
    videoBackgroundColor
  } = props;
  const { isDesktop } = useContext(Context);
  if (!is_visible) return null;

  return (
    <CardWrapper>
      <HeaderSection style={{ color: headerColor }}>
        <HeaderNumber>{lieNumber}</HeaderNumber>
        <HeaderQuote
          dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(lieQuote || "") }}
          style={{ color: headerColor }}
        />
      </HeaderSection>
      <Divider />

      <ContentSection>
        <BulletContainer>
          {bulletPoints?.map((bullet, index) => (
            <React.Fragment key={index}>
              <BulletItem>
                {bullet.icon && (
                  <IconWrapper>
                    <ImageContainer
                      imgSrc={bullet.icon}
                      alt={`bullet-icon-${index}`}
                      width={isDesktop ? 64 : 40}
                      height={isDesktop ? 64 : 40}
                      isResolvePath={true}
                    />
                  </IconWrapper>
                )}
                <BulletText
                  dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(bullet.text)
                  }}
                />
              </BulletItem>
              {index < bulletPoints.length - 1 && <BulletDivider />}
            </React.Fragment>
          ))}
        </BulletContainer>
      </ContentSection>
      {videoSrc && (
        <VideoWrapper>
          <video src={resolvePath(videoSrc)} controls width="100%"/>
        </VideoWrapper>
      )}
    </CardWrapper>
  );
};

export default connect()(ClaimLieCard);
